module.exports = "<div class=\"table-responsive\">\n    <chassis-datatable [ajax]=\"table?.ajax\" [serverSide]=\"true\" [datatables]=\"true\" [columns]=\"table?.columns\" [click]=\"table?.callbacks['click']\" (instance)=\"setDatatableInstance($event)\"></chassis-datatable>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./libs/donna-core/src/app/tax/plugins/tax-settings/tax-settings.plugin.html
// module id = ./libs/donna-core/src/app/tax/plugins/tax-settings/tax-settings.plugin.html
// module chunks = main